<script setup lang="ts">
import { QrcodeStream } from 'vue-qrcode-reader'

import axios from 'axios'

const { t } = useI18n()
const notification = useNotification()
const router = useRouter()

const devices = ref([])
const result = ref(null)
const paused = ref(false)
const loading = ref(true)
const facingMode = ref('environment')
const barcodeFormats = [
  'ean_13',
  'ean_8',
  'qr_code',
  'rm_qr_code',
  'linear_codes',
  'code_128',
  'code_39',
  'code_93',
  'codabar',
  'databar',
  'ean_13',
  'ean_8',
  'itf'
]

const checkKnownCustomer = async (value: string) => {
  paused.value = true

  try {
    const response = await axios.get(`customers/public/${value}`)
    if (response.status === 200) {
      router.push({ name: 'CustomerDetail', params: { customerId: value } })
    }
  } catch (e) {
    if (e.response.status === 404) {
      displayError(t('pages.customer.customerScanningPage.errors.unknownCustomer'))
    }
  }
}

const onCameraOn = async () => {
  devices.value = (await navigator.mediaDevices.enumerateDevices()).filter(({ kind }) => kind === 'videoinput')
  loading.value = false
}

const switchCamera = () => {
  if (facingMode.value === 'environment') {
    facingMode.value = 'user'
  } else {
    facingMode.value = 'environment'
  }
}

const onDetect = (detectedCodes: any[]) => {
  const firstDetectedValue = detectedCodes[0]?.rawValue
  result.value = JSON.stringify(firstDetectedValue)
  checkKnownCustomer(firstDetectedValue)
}
const onError = (err: { name: string }) => {
  displayError(
    t(`pages.customer.customerScanningPage.errors.${err.name}`) ||
      t(`pages.customer.customerScanningPage.errors.default`)
  )
}

const displayError = (errorMessage) => {
  notification.create('error', {
    text: errorMessage,
    timeout: 5000
  })
  paused.value = false
}

onMounted(async () => {
  await onCameraOn()
})
</script>
<template>
  <div class="flex h-screen flex-col items-center">
    <div class="w-fill flex h-2/3 items-center justify-center sm:h-full">
      <div class="relative h-full w-full">
        <qrcode-stream
          v-if="devices.length > 0"
          :constraints="{ facingMode }"
          :paused="paused"
          :formats="barcodeFormats"
          class="h-fill w-fill absolute inset-0"
          @camera-on="onCameraOn"
          @error="onError"
          @detect="onDetect"
        >
          <div class="hidden h-full w-full items-center justify-center p-6 sm:flex">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="#FEFEFA">
              <path
                d="M25 5C13.954 5 5 13.954 5 25v9h3v-9c0-9.389 7.611-17 17-17h9V5zm41 0v3h9c9.389 0 17 7.611 17 17v9h3v-9c0-11.046-8.954-20-20-20zM5 66v9c0 11.046 8.954 20 20 20h9v-3h-9c-9.389 0-17-7.611-17-17v-9zm87 0v9c0 9.389-7.611 17-17 17h-9v3h9c11.046 0 20-8.954 20-20v-9z"
              />
            </svg>
          </div>
        </qrcode-stream>
        <span v-else-if="loading">{{ t('pages.customer.customerScanningPage.loading') }}</span>
      </div>
    </div>
    <div v-if="devices.length > 1" class="flex w-full items-center justify-center">
      <div class="flex flex-col items-center">
        <button class="mt-4 w-min rounded-full border-2 border-primary p-3" @click="switchCamera">
          <BaseIcon name="HeroArrowPathIconSolid" class="h-6 w-6 font-light text-primary" />
        </button>
      </div>
    </div>
  </div>
</template>
